import { useStore } from 'vuex';

export default defineNuxtRouteMiddleware(async () => {
  const store = useStore();

  // Only initialize once per app lifecycle (now includes both app shell and footer)
  if (!store.state.app.initialized) {
    await store.dispatch('app/initShell');
  }
});
